export default "__VITE_ASSET__lZP2fjiA__"